<template>
  <div class="center grid">
    <vs-row justify="space-around">
      <vs-col w="4">
        <img
          style="width: 100%; margin-top: 20px"
          alt="Justconsult logo"
          src="@/assets/logoJust.svg"
          @click="closePad()"
        />
      </vs-col>
    </vs-row>
    <vs-row v-if="showMarkPage" justify="space-around">
      <div class="inner-container">
        <div class="feedback-container">
          <h1 style="margin-bottom: 36px" class="mb-6">Cât de mulțumit(ă) sunteți de experiența pe care ați avut-o cu
            JustConsult?</h1>
          <p v-if="selectedEmoji !== null" class="selected-result mt-4">
            <strong style="font-weight: 800;">Nota {{
                feedbackOptions[selectedEmoji].mark + ' - ' + feedbackOptions[selectedEmoji].label
              }}</strong>
          </p>
          <vs-row class="emoji-row" :class="{ minimized: isTextareaFocused }" justify="center">
            <div
              v-for="(option, index) in feedbackOptions"
              :key="index"
              class="emoji-option"
              :class="{ selected: selectedEmoji === index }"
              @click="selectEmoji(index)"
            >
              <div class="emoji">{{ option.emoji }}</div>
              <div class="emoji-mark">{{ option.mark }}</div>
              <div class="label">{{ option.label }}</div>
            </div>
          </vs-row>
          
          <!-- Textarea stilizat ca Vuesax -->
          <div class="comment-section" v-if="selectedEmoji !== null">
            <vs-row justify="center">
              <vs-col w="12">
                <div class="custom-textarea-wrapper"
                     :class="{ expanded: isTextareaExpanded, focused: isTextareaFocused }">
                  <label class="custom-textarea-label" :class="{ active: clientComment || isTextareaFocused }">
                    Cum am putea îmbunătăți experiența?
                  </label>
                  <textarea
                    v-model="clientComment"
                    class="custom-textarea"
                    placeholder="Comentariu (opțional)"
                    @focus="onTextareaFocus"
                    @blur="onTextareaBlur"
                    :rows="isTextareaExpanded ? 6 : 3"
                  ></textarea>
                  <div class="custom-textarea-border"></div>
                  <vs-button
                    v-if="isTextareaExpanded"
                    class="collapse-button"
                    @click="collapseTextarea"
                    size="small"
                    circle
                    floating
                    color="rgba(var(--vs-gray-2), 1)"
                  >
                    <i class="bx bx-x" style="color: #000; font-size: 16px"></i>
                  </vs-button>
                </div>
              </vs-col>
            </vs-row>
          </div>
          <!-- Buttons section -->
          <div class="buttons-section">
            <vs-button
              size="xl"
              style="padding: 10px; font-weight: bold"
              color="#A8A8A8"
              rounded
              icon
              @click="skipFeedback"
            >
              Omite
              <i class="bx bx-arrow-back arrow-right-rotated" style="font-size: 28px; margin-left: 18px"></i>
            </vs-button>
            <vs-button
              v-if="selectedEmoji !== null"
              @click="submitFeedback"
              color="primary"
              size="large"
              class="submit-button"
            >
              Trimite Răspunsul
            </vs-button>
          </div>
        </div>
      </div>
    </vs-row>
    <!-- <ServicesList style="margin-top: 10vh" /> -->
    <vs-row>
      <vs-alert color="danger" v-if="showWsDisconnect">
        <template #title> Eroare conexiune </template>
        <b>Conexiunea cu serverul WebSocket a eșuat</b>
      </vs-alert>

      <vs-dialog blur v-model="alert">
        <template #header>
          <h4 class="not-margin" :color="alertContent.color">
            {{ alertContent.title }}
          </h4>
        </template>

        {{ alertContent.msg }}

        <template #footer>
          <div class="footer-dialog">
            <vs-button :color="alertContent.color" block @click="alert = false">
              OK
            </vs-button>
          </div>
        </template>
      </vs-dialog>
    </vs-row>
    <vs-row class="container" justify="center" v-if="showSignaturePad && !showMarkPage">
      <h3 class="headerText">Aplicați semnătura în câmpul de mai jos</h3>
      <vs-row justify="center">
        <VueSignaturePad
          width="800px"
          height="300px"
          class="pad"
          ref="signaturePad"
        />
      </vs-row>
      <vs-row justify="center" v-if="selectedDMS">
        <vs-col w="6">
          <h4>
            S.R.L. „JustConsult” preia semnătura în scopul semnării versiunii
            electronice a contractului nr. <b>{{ selectedDMS }}</b> din data de
            {{ currentDate() }}. Garantăm utilizarea semnăturii doar în scopul
            expus mai sus.
          </h4>
        </vs-col>
      </vs-row>
      <vs-row justify="center" style="margin-top: 20px">
        <vs-button
          v-if="emojiIsSkipped"
          size="large"
          style="padding: 10px; font-weight: bold"
          color="#A8A8A8"
          square
          icon
          @click="goBack"
        >
          <i class="bx bx-arrow-back" style="font-size: 28px; margin-right: 18px"></i>
          Înapoi
        </vs-button>
        <vs-button
          size="medium"
          style="padding: 10px; font-weight: bold"
          color="#ee5d5d"
          square
          icon
          @click="clear"
        >
          ȘTERGE <i class="bx bx-refresh" style="font-size: 25px"></i>
        </vs-button>
        <vs-button
          size="xl"
          style="padding: 10px 38px; font-weight: bold"
          success
          square
          icon
          @click="save"
        >
          ACCEPTĂ
          <i class="bx bx-check" style="font-weight: bold; padding-left: 10px; font-size: 25px"></i>
        </vs-button>
      </vs-row>
    </vs-row>
  </div>
</template>

<script>
//import ServicesList from "@/components/ServicesList";
export default {
  name: "MainComponent",
  components: {
    //  ServicesList: ServicesList,
  },
  data: () => {
    return {
      showWsDisconnect: false,
      showSignaturePad: false,
      isSigning: false,
      selectedDMS: null,
      token: null,
      alert: false,
      alertContent: {
        title: "",
        msg: "",
        time: 6000,
        progress: 0,
        color: "danger",
      },
      settingsModal: false,
      deviceID: "",
      selectedDeviceID: "",
      // emojis: ['👎', '🙁', '😑', '😃', '🤩'],
      // emojis: ['😠', '🙁', '🙂😑', '😃', '🤩😊'],
      clientComment: '',
      isTextareaExpanded: false,
      isTextareaFocused: false,
      feedbackOptions: [
        { mark: 1, emoji: '😡', label: 'Dezamăgit!' },
        { mark: 2, emoji: '🙁', label: 'Nu prea bine' },
        { mark: 3, emoji: '😐', label: 'Neutru' },
        { mark: 4, emoji: '🙂', label: 'Mulțumit' },
        { mark: 5, emoji: '🤩', label: 'Foarte bine!' }
      ],
      selectedEmoji: null,
      markGiven: null,
      emojiIsSkipped: null,
    };
  },
  sockets: {
  },
  methods: {
    onTextareaFocus () {
      this.isTextareaFocused = true
      this.expandTextarea()
    },
    onTextareaBlur () {
      this.isTextareaFocused = false
    },
    expandTextarea () {
      this.isTextareaExpanded = true
    },
    collapseTextarea () {
      this.isTextareaExpanded = false
    },
    currentDate() {
      const currentDate = new Date();
      return this.formatDate(currentDate, "dd.mm.yyyy");
    },
    formatDate(date, format) {
      const map = {
        mm: ("0" + (date.getMonth() + 1)).slice(-2),
        dd: ("0" + date.getDate()).slice(-2),
        yy: date.getFullYear().toString().slice(-2),
        yyyy: date.getFullYear(),
      };

      return format.replace(/mm|dd|yyyy/gi, (matched) => map[matched]);
    },
    openLoading(token) {
      const loading = this.$vs.loading({
        type: "circles",
        color: "#880516",
      });
      this.token = token
      setTimeout(() => {
        loading.close();
        this.showSignaturePad = true;
        this.isSigning = true;
      }, 1000);
    },
    clear() {
      this.$refs.signaturePad?.clearSignature();
    },
    closePad() {
      this.showSignaturePad = false;
      this.isSigning = false;
      this.selectedDMS = null;
      this.clear()
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.$http
          .post("dms/remote-sign", { image: data, token: this.token })
          .then(
            () => {
              this.displaySuccess();
              this.closePad();
            },
            () => {
              this.displayError();
            }
          );
      }
    },
    displaySuccess() {
      this.alertContent = {
        title: "Semnătura a fost aplicată cu succes!",
        msg:
          "Semnătura pentru contractul " +
          this.selectedDMS +
          " a fost aplicată cu success!",
        time: 2000,
        progress: 0,
        color: "success",
      };
      this.alert = true;
    },
    displayError() {
      this.alertContent = {
        title: "Eroare!",
        msg:
          "Semnătura pentru contractul " +
          this.selectedDMS +
          "nu a putut fi aplicată!",
        time: 8000,
        progress: 0,
        color: "danger",
      };
      this.alert = true;
    },
    selectEmoji (index) {
      this.selectedEmoji = index
    },
    submitFeedback () {
     // Includem comentariul în feedback
      const feedback = {
	token: this.token,
        mark: this.selectedEmoji + 1,
        dms: this.selectedDMS,
        comment: this.clientComment
      };
      if (feedback?.mark) {
        this.markGiven = true
        this.$http.post('dms/remote-mark', feedback).then(
          () => {
            console.log('Success mark')
          },
          (err) => {
            console.error(err)
          }
        )
        console.log('Feedback submitted:', feedback)
        // Reset după trimitere
        this.selectedEmoji = null
        this.clientComment = ''
        this.isTextareaExpanded = false
        this.isTextareaFocused = false
      }
    },
    skipFeedback() {
      this.markGiven = true
      this.emojiIsSkipped = true
      console.log('Feedback skipped for DMS:', this.selectedDMS)
      this.isTextareaExpanded = false
      this.isTextareaFocused = false
    },
    goBack() {
      this.markGiven = false
      this.emojiIsSkipped = false
      this.isTextareaExpanded = false
      this.isTextareaFocused = false
    },
  },
  watch: {
    alert(val) {
      if (val) {
        this.alert = true;

        var interval = setInterval(() => {
          this.alertContent.progress++;
        }, this.alertContent.time / 100);

        setTimeout(() => {
          this.alert = false;
          clearInterval(interval);
          this.alertContent.progress = 0;
        }, this.alertContent.time);
      }
    },
  },
  mounted: function () {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    const dms = params.get('dms')
    console.log({v: token})
    if (token) {
      this.selectedEmoji = null
      this.clientComment = ''
      this.selectedDMS = dms
      this.markGiven = false
      this.emojiIsSkipped = false
      this.openLoading(token);
    }
    // if (!localStorage.getItem("deviceID")) {
    //   this.settingsModal = true;
    // } else {
    //   this.selectedDeviceID = localStorage.getItem("deviceID");
    // }
  },
  computed: {
    showMarkPage () {
      return this.markGiven !== true && this.selectedDMS
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.pad {
  background: rgba(var(--vs-background), 1);
  color: rgba(var(--vs-text), 1);
  -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, var(--vs-shadow-opacity));
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, var(--vs-shadow-opacity));
  border-radius: 20px;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  cursor: pointer;
  position: relative;
}

.headerText {
  font-size: 12pt;
}

.container {
  margin-top: 10px;
}

.container h3 {
  font-size: 20pt;
  color: #880516;
}

.feedback-container {
  margin: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  position: relative;
}
.buttons-section {
  margin-top: 20px;
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: center;
}
.submit-button {
  padding: 12px 24px !important;
  margin: 0 !important;
}
.arrow-right-rotated {
  transform: rotate(180deg);
  display: inline-block;
}

.emoji-row {
  gap: 15px;
  flex-wrap: wrap;
  transition: all 0.5s ease;
  transform-origin: center;
}

.emoji-row.minimized {
  transform: scale(0.5);
  margin-bottom: -30px;
  margin-top: -30px;
  opacity: 0.8;
}

.emoji-option {
  cursor: pointer;
  padding: 10px;
  width: 120px;
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.emoji-option:hover {
  background-color: #f5f5f5;
}

.emoji-option.selected {
  border-color: #2d9cdb;
  background-color: #e6f7ff;
}

.emoji-row.minimized .emoji-option:not(.selected) {
  opacity: 0.9;
}

.emoji-row.minimized .emoji-option.selected {
  opacity: 1;
  transform: scale(1.1);
}

.emoji {
  font-size: 42px;
}

.emoji-mark {
  font-size: 16px;
  margin-top: 16px;
  font-weight: 500;
  color: #333;
}

.label {
  font-size: 16px;
  margin-top: 16px;
  font-weight: 700;
  color: #333;
}

.selected-result {
  font-size: 16px;
  color: #444;
}

.comment-section {
  margin-top: 20px;
  width: 100%;
  animation: slideInUp 0.5s ease;
}

.custom-textarea-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.custom-textarea-wrapper.expanded {
  transform: scale(1.01);
}

.custom-textarea {
  width: 100%;
  padding: 16px;
  border: 2px solid rgba(var(--vs-gray-2), 1);
  border-radius: 12px;
  font-size: 14px;
  font-family: inherit;
  line-height: 1.4;
  transition: all 0.3s ease;
  outline: none;
  background: rgba(var(--vs-background), 1);
  color: rgba(var(--vs-text), 1);
  min-height: 60px;
}

.custom-textarea:focus {
  border-color: rgba(var(--vs-primary), 1);
  box-shadow: 0 0 0 3px rgba(var(--vs-primary), 0.1);
}

.custom-textarea::placeholder {
  color: rgba(var(--vs-text), 1);
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.custom-textarea:focus::placeholder {
  opacity: 0!important;
}

.custom-textarea-wrapper.focused .custom-textarea-border {
  width: 100%;
}

.custom-textarea-wrapper.expanded .custom-textarea {
  min-height: 60px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.custom-textarea-wrapper.focused .custom-textarea {
  min-height: 120px;
}
.custom-textarea-wrapper textarea {
  height: 80px!important;
}
.custom-textarea-wrapper.expanded textarea {
  height: 80px!important;
}

.collapse-button {
  position: absolute !important;
  top: 12px;
  right: 2px;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  background: rgba(var(--vs-background), 1) !important;
  backdrop-filter: blur(10px);
}

.collapse-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2) !important;
}

/* Animații pentru tranziții frumoase */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
